import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setApplication } from "actions";
import { appsUrls } from "./getRoutes";

function getAppFromPathname(pathname = "*") {
  let application = "EMAILING";

  for (let app in appsUrls) {
    if (
      Object.values(appsUrls[app]).some((url) =>
        new RegExp(url.replace(/\/:.+/g, "")).test(pathname),
      )
    ) {
      application = app;
      break;
    }
  }

  return application;
}

export default function AppRouteListener() {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const app = getAppFromPathname(location.pathname);
    dispatch(setApplication(app));
  }, [location.pathname, dispatch]);

  return null;
}
